/**
 * Shared color constants for JavaScript chart rendering.
 *
 * Colors are retrieved from CSS variables defined in brandings/_styles.html.erb,
 * which are generated from lib/brandings/colors.rb
 */

/**
 * Gets the computed value of a CSS variable from :root.
 * Falls back to the provided default if the variable is not defined.
 */
function getCssVar(varName, fallback) {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(varName)
    .trim();
  return value || fallback;
}

export const PURPLE_400 = getCssVar('--purple-400', '#CF44D3');
export const PURPLE_500 = getCssVar('--purple-500', '#A227A5');

export const GREEN_400 = getCssVar('--green-400', '#4DD89C');

export const BLUE_400 = getCssVar('--blue-400', '#5384E6');

export const YELLOW_500 = getCssVar('--yellow-500', '#FFAF02');

export const RED_500 = getCssVar('--red-500', '#FF5146');

export const GRAY_700 = getCssVar('--gray-700', '#374151');
export const SLATE_500 = getCssVar('--slate-500', '#64748B');
